import { render, staticRenderFns } from "./BookablePositionEdit.vue?vue&type=template&id=5a71d3b0&scoped=true"
import script from "./BookablePositionEdit.vue?vue&type=script&lang=js"
export * from "./BookablePositionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71d3b0",
  null
  
)

export default component.exports